import { mergeDeep } from '@/helpers/utils'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import main4049Webp from '@/assets/landing-age-selection/main-40-49.webp'
import main5059Webp from '@/assets/landing-age-selection/main-50-59.webp'
import main6069Webp from '@/assets/landing-age-selection/main-60-69-walking.webp'
import main7080Webp from '@/assets/landing-age-selection/main-70-80.webp'
import femaleWalking from '@/assets/landing/female-walking-loader.webp'

export default (schemas: LandingScreenSchema[]): LandingScreenSchema[] => {
	const extensionSchema: Partial<LandingScreenSchema>[] = [
		{
			order: ['LandingHead', 'LandingTitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],
			components: {
				LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
					title: 'Indoor Walking Plan Based on Your Age',
					size: 'small',
					customStyles: {
						marginLeft: '3rem',
						marginRight: '3rem',
					},
				}),
				LandingImage: (): LandingComponentsConfig['LandingImage'] => {
					return {
						img: femaleWalking,
						customStyles: {
							height: '42vh',
						},
					}
				},
			},
		},
		{
			components: {
				LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
					title: 'Indoor walking plan',
					size: 'large',
					uppercase: true,
				}),
				LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
					theme: 'blue',
					ageRanges: [
						{
							value: 40,
							analyticValue: '40-49',
							label: $t('female_yoga.pages.landing.age_range.40_49'),
							img: main4049Webp,
						},
						{
							value: 50,
							analyticValue: '50-59',
							label: $t('female_yoga.pages.landing.age_range.50_59'),
							img: main5059Webp,
						},
						{
							value: 60,
							analyticValue: '60-69',
							label: $t('female_yoga.pages.landing.age_range.60_69'),
							img: main6069Webp,
						},
						{
							value: 70,
							analyticValue: '70+',
							label: $t('female_yoga.pages.landing.age_range.70_80'),
							img: main7080Webp,
						},
					],
					otherAgesButton: {
						data: { value: 18, analyticValue: '18-39' },
						text: $t('female_yoga.pages.landing.im_young'),
					},
				}),
			},
		},
	]

	return mergeDeep([...schemas], extensionSchema)
}
